/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;

        // Always show when clicked - ignore cookie's dismissed days and show on mobile settings
        if (this.dataset.triggerUrl === 'true') {
          this.urlHandler = this.handleURL.bind(this);
          this.urlID = this.dataset.urlId;
          window.addEventListener('DOMContentLoaded', this.urlHandler);
          window.addEventListener('hashchange', this.urlHandler);
        }
        
        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (!getCookie(this.cookie) && (this.dataset.showOnMobile === 'true' || theme.mediaMatches.md)) {
          if (this.querySelector('.alert')) {
            this.open();
          } 
          if (this.dataset.triggerDelay === 'true') {
            setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
          }
          if (this.dataset.triggerExit === 'true' && theme.mediaMatches.md) {
            this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
            document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
          } 
          if (this.dataset.triggerScroll === 'true') {
            this.scrollHandler = this.scrollHandler || this.handleScroll.bind(this);
            this.scrollThreshold = parseInt(this.dataset.scroll);
            window.addEventListener('scroll', this.scrollHandler);
          }
        }
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }
        if (this.scrollHandler) {
          window.removeEventListener('scroll', this.scrollHandler);
        }
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseLeave(evt) {
        if (evt.clientY < 0 && !getCookie(this.cookie)) this.open();
      }

      handleScroll() {
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrolled = (winScroll / height) * 100;
        if (scrolled > this.scrollThreshold && !getCookie(this.cookie)) this.open();
      }

      handleURL() {
        // document.querySelectorAll(`[href="#${this.urlID}"]`).forEach((el) => {
        //   el.addEventListener('click', this.open.bind(this, el));
        // });

        if (window.location.href.indexOf(`#${this.urlID}`) != -1) {
          this.open();
        }
        let noHashURL = window.location.href.replace(`#${this.urlID}-sign-up`, '');
        noHashURL = noHashURL.replace(`#${this.urlID}`, '');

        window.history.replaceState("", document.title, noHashURL);
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        setCookie(this.cookie, true, parseInt(this.dataset.dismissDays, 10)); // Fixed - call setCookie before super.close()
        super.close();
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
